import * as types from '../modules/emsCli/mutationTypes'
const state = {
  // 微信签名验证
  signatureVerification: {
    appId: '',
    timestamp: '',
    nonceStr: '',
    signature: '',
    jsApiList: [],
    openTagList: []
  }
}

const mutations = {
  [types.SET_SIGNATURE_VERIFICATION] (state, data) {
    state.signatureVerification = data
  }
}

const actions = {
  // 设置微信全局签名
  setSignatureVerification ({ commit }, data) {
    commit(types.SET_SIGNATURE_VERIFICATION, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
